var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisitsHover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.861,
    height: 28.701,
    viewBox: "0 0 27.861 28.701",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3",
    "data-name": "Groupe 3",
    transform: "translate(-0.65 -0.65)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_7",
    "data-name": "Trac\\xE9 7",
    d: "M6.837,9.361C3.3,8.481,1,7.064,1,5.466V16.757c0,1.573,2.224,2.97,5.668,3.852a.512.512,0,0,0,.638-.5V9.957a.615.615,0,0,0-.469-.6Z",
    fill: "none",
    stroke: "#35ce92",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_8",
    "data-name": "Trac\\xE9 8",
    d: "M14.58,1C7.08,1,1,3.163,1,5.831V17.123c0-2.051,3.591-3.8,8.657-4.5V12a2.487,2.487,0,0,1,2.42-2.549h3.642a1.247,1.247,0,0,1,1.424,1.139.644.644,0,0,0,.691.53,1.111,1.111,0,0,1,1.136,1.142v.289c5.346.649,9.191,2.451,9.191,4.573V5.831C28.16,3.163,22.08,1,14.58,1Z",
    fill: "none",
    stroke: "#35ce92",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9",
    "data-name": "Trac\\xE9 9",
    d: "M17.2,13.9a.068.068,0,0,0-.128-.033,2.547,2.547,0,0,1-2.248,1.349h-3.9V17.8a3.661,3.661,0,0,0,7.322,0V15.184A1.321,1.321,0,0,1,17.2,13.9Z",
    fill: "none",
    stroke: "#35ce92",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_10",
    "data-name": "Trac\\xE9 10",
    d: "M18.028,10.729a.673.673,0,0,1-.728-.53c-.112-.572-.395-1.139-1.5-1.139H11.965a2.549,2.549,0,0,0-2.549,2.549v2.8a1.073,1.073,0,0,0,1.073,1.073h4.353a2.547,2.547,0,0,0,2.248-1.349.068.068,0,0,1,.128.033,1.32,1.32,0,0,0,1.316,1.316.692.692,0,0,0,.69-.69V11.873a1.143,1.143,0,0,0-1.2-1.144Z",
    fill: "none",
    stroke: "#35ce92",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11",
    "data-name": "Trac\\xE9 11",
    d: "M14.633,25.754a3.614,3.614,0,0,0,3.523-2.828l-1.318-.51a.366.366,0,0,1-.234-.34v-1.2a3.585,3.585,0,0,1-1.97.588,3.786,3.786,0,0,1-2.078-.593v1.2a.337.337,0,0,1-.156.3l-1.4.545a3.617,3.617,0,0,0,3.633,2.839Z",
    fill: "none",
    stroke: "#35ce92",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_12",
    "data-name": "Trac\\xE9 12",
    d: "M10.738,15.3a1.072,1.072,0,0,1-.888-.47,1.435,1.435,0,0,0,.34,2.83h1V15.3Z",
    fill: "none",
    stroke: "#35ce92",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_13",
    "data-name": "Trac\\xE9 13",
    d: "M18.966,14.785H18.9a.692.692,0,0,1-.666.512,1.3,1.3,0,0,1-.272-.029v2.389h1a1.436,1.436,0,0,0,0-2.872Z",
    fill: "none",
    stroke: "#35ce92",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_14",
    "data-name": "Trac\\xE9 14",
    d: "M8.713,26.763v1.669",
    fill: "none",
    stroke: "#35ce92",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_15",
    "data-name": "Trac\\xE9 15",
    d: "M20.448,26.763v1.669",
    fill: "none",
    stroke: "#35ce92",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16",
    "data-name": "Trac\\xE9 16",
    d: "M9.762,4.469a1,1,0,1,1,.984,1.166",
    fill: "none",
    stroke: "#35ce92",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_17",
    "data-name": "Trac\\xE9 17",
    d: "M9.762,6.8a1,1,0,1,0,.984-1.166",
    fill: "none",
    stroke: "#35ce92",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_18",
    "data-name": "Trac\\xE9 18",
    d: "M14.2,7.633a1.23,1.23,0,1,0-1.23-1.23A1.23,1.23,0,0,0,14.2,7.633Z",
    fill: "none",
    stroke: "#35ce92",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_19",
    "data-name": "Trac\\xE9 19",
    d: "M14.571,3.638a3.146,3.146,0,0,0-1.6,2.764",
    fill: "none",
    stroke: "#35ce92",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_20",
    "data-name": "Trac\\xE9 20",
    d: "M17.779,3.638a1.136,1.136,0,0,0-1.136,1.136V6.5a1.136,1.136,0,1,0,2.273,0V4.774a1.136,1.136,0,0,0-1.137-1.136Z",
    fill: "none",
    stroke: "#35ce92",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_21",
    "data-name": "Trac\\xE9 21",
    d: "M21.14,5.545a1,1,0,1,0-1-1A1,1,0,0,0,21.14,5.545Z",
    fill: "none",
    stroke: "#35ce92",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22",
    "data-name": "Trac\\xE9 22",
    d: "M15.51,29h7.031a.7.7,0,0,0,.667-.723V27.47a3.4,3.4,0,0,0-1.826-3.07l-4.718-1.98a.367.367,0,0,1-.216-.34v-1.2a3.13,3.13,0,0,1-1.818.588,3.3,3.3,0,0,1-1.917-.593V22.07a.344.344,0,0,1-.144.3L7.782,24.4a3.4,3.4,0,0,0-1.826,3.07v.811A.7.7,0,0,0,6.623,29h7.031",
    fill: "none",
    stroke: "#35ce92",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_23",
    "data-name": "Trac\\xE9 23",
    d: "M26.75,18.85a2.726,2.726,0,0,0,1.409-2.093V5.466c0,1.6-2.3,3.015-5.837,3.895a.615.615,0,0,0-.469.6V20.117a.512.512,0,0,0,.638.5,18.284,18.284,0,0,0,2.48-.812",
    fill: "none",
    stroke: "#35ce92",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.7
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisitsHover);
export default __webpack_public_path__ + "static/media/visits-hover.7ed59cff67feba9a7859c1db553d5904.svg";
export { ForwardRef as ReactComponent };